import { render, staticRenderFns } from "./MemberSpec.vue?vue&type=template&id=a83499d6&scoped=true"
import script from "./MemberSpec.vue?vue&type=script&lang=js"
export * from "./MemberSpec.vue?vue&type=script&lang=js"
import style0 from "./MemberSpec.vue?vue&type=style&index=0&id=a83499d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a83499d6",
  null
  
)

export default component.exports